export const FALLBACK_VARIABLE_GROUPS = [
  { group: 'Empresa/Filial', items: [
    { path: 'company.name', label: 'Nome da Empresa' },
    { path: 'company.nuit', label: 'NUIT' },
    { path: 'company.bank_account_holder', label: 'Titular da Conta' },
    { path: 'company.bank_name', label: 'Banco' },
    { path: 'company.bank_account_number', label: 'Número da Conta' },
    { path: 'company.bank_iban', label: 'IBAN' },
    { path: 'company.bank_nib', label: 'NIB' },
    { path: 'company.bank_swift', label: 'SWIFT' },
    { path: 'company.banks[0].label', label: 'Banco 1 · Etiqueta' },
    { path: 'company.banks[0].bank_name', label: 'Banco 1 · Nome' },
    { path: 'company.banks[0].bank_account_number', label: 'Banco 1 · Conta' },
    { path: 'company.banks[1].label', label: 'Banco 2 · Etiqueta' },
    { path: 'company.banks[1].bank_name', label: 'Banco 2 · Nome' },
    { path: 'company.banks[1].bank_account_number', label: 'Banco 2 · Conta' },
    { path: 'company.banks[2].label', label: 'Banco 3 · Etiqueta' },
    { path: 'company.banks[2].bank_name', label: 'Banco 3 · Nome' },
    { path: 'company.banks[2].bank_account_number', label: 'Banco 3 · Conta' },
    { path: 'branch.name', label: 'Nome Filial' },
    { path: 'branch.address', label: 'Morada Filial' },
    { path: 'branch.contacts', label: 'Contactos Filial' },
    { path: 'branch.email', label: 'Email Filial' },
    { path: 'branch.website', label: 'Website Filial' },
  ]},
  { group: 'Documento/Serviço', items: [
    { path: 'doc.number', label: 'Nº Documento' },
    { path: 'doc.date', label: 'Data/Hora Documento' },
    { path: 'doc.date_only', label: 'Data (sem hora)' },
    { path: 'doc.datetime', label: 'Data/Hora (Maputo)' },
    { path: 'doc.issued_at', label: 'Emitido em (ISO)' },
    { path: 'doc.printed_at_display', label: 'Impresso em (Maputo)' },
    { path: 'doc.printed_at', label: 'Impresso em (ISO)' },
    { path: 'sale.number', label: 'Nº Venda' },
    { path: 'sale.fiscal_number', label: 'Nº Fiscal' },
    { path: 'sale.employee', label: 'Vendedor' },
    { path: 'sale.location', label: 'Loja/Filial' },
    { path: 'sale.created_at_display', label: 'Venda criada em (Maputo)' },
    { path: 'sale.created_at', label: 'Venda criada em (ISO)' },
    { path: 'service.number', label: 'Nº Serviço' },
    { path: 'service.status', label: 'Estado' },
    { path: 'service.priority', label: 'Prioridade' },
  ]},
  { group: 'Cliente', items: [
    { path: 'customer.name', label: 'Nome Cliente' },
    { path: 'customer.phone', label: 'Telefone' },
    { path: 'customer.email', label: 'Email' },
    { path: 'customer.nuit', label: 'NUIT Cliente' },
    { path: 'customer.address', label: 'Morada Cliente' },
    { path: 'customer.city', label: 'Cidade Cliente' },
    { path: 'customer.contact_person', label: 'Pessoa de Contacto' },
  ]},
  { group: 'Equipamento', items: [
    { path: 'device.category', label: 'Categoria' },
    { path: 'device.brand', label: 'Marca' },
    { path: 'device.model', label: 'Modelo' },
    { path: 'device.serial', label: 'Nº Série' },
    { path: 'device.imei', label: 'IMEI' },
  ]},
  { group: 'Totais e Impostos', items: [
    { path: 'totals.subtotal', label: 'Subtotal' },
    { path: 'totals.discount_value', label: 'Valor Desconto' },
    { path: 'totals.discount_percent', label: '% Desconto' },
    { path: 'totals.financial_discount', label: 'Desc. Financeiro' },
    { path: 'totals.taxable_base', label: 'Base Tributável' },
    { path: 'totals.vat_rate', label: 'Taxa IVA' },
    { path: 'totals.vat_value', label: 'Valor IVA' },
    { path: 'totals.total', label: 'Total' },
    { path: 'totals.total_paid', label: 'Total Pago' },
    { path: 'totals.balance_due', label: 'Saldo a Pagar' },
    { path: 'totals.withholding_tax_value', label: 'Retenção na Fonte' },
    { path: 'totals.exemption_reason', label: 'Motivo Isenção IVA' },
  ]},
  { group: 'Resumo Impostos (tax_summary)', items: [
    { path: 'tax_summary[0].rate', label: 'Taxa (%)' },
    { path: 'tax_summary[0].base', label: 'Base Tributável' },
    { path: 'tax_summary[0].vat', label: 'Valor IVA' },
  ]},
  { group: 'Linha de Item (items[])', items: [
    { path: 'items[0].description', label: 'Descrição Item' },
    { path: 'items[0].qty', label: 'Quantidade' },
    { path: 'items[0].unit_price', label: 'Preço Unitário' },
    { path: 'items[0].line_subtotal', label: 'Subtotal Linha' },
    { path: 'items[0].line_discount', label: 'Desconto Linha' },
    { path: 'items[0].line_vat', label: 'IVA Linha' },
    { path: 'items[0].line_total', label: 'Total Linha' },
  ]},
  { group: 'Pagamentos (payments[])', items: [
    { path: 'payments[0].amount', label: 'Valor Pagamento' },
    { path: 'payments[0].method', label: 'Forma de Pagamento' },
    { path: 'payments[0].reference', label: 'Referência' },
    { path: 'payments[0].date', label: 'Data Pagamento' },
  ]},
  { group: 'Serviço (valores base)', items: [
    { path: 'totals.diagnostic', label: 'Diagnóstico' },
    { path: 'totals.labour', label: 'Mão de Obra' },
    { path: 'totals.parts', label: 'Peças' },
  ]},
];

export const FALLBACK_TABLE_DATASOURCES = [
  { value: 'items', label: 'Tabela Items (Peças/Produtos)', defaultColumns: [
    { field: 'description', label: 'Descrição', width: 200, align: 'left' },
    { field: 'qty', label: 'Qtd', width: 45, align: 'center' },
    { field: 'unit_price', label: 'Preço', width: 85, align: 'right' },
    { field: 'vat_rate', label: 'IVA', width: 60, align: 'right' },
    { field: 'line_total', label: 'Total', width: 85, align: 'right' },
  ], fields: [
    { value: 'description', label: 'Descrição' },
    { value: 'qty', label: 'Qtd' },
    { value: 'unit_price', label: 'Preço' },
    { value: 'vat_rate', label: 'IVA %' },
    { value: 'line_total', label: 'Total' },
    { value: 'sku', label: 'Artigo / Código' },
    { value: 'unit', label: 'Unidade' },
    { value: 'line_discount', label: 'Desconto' },
    { value: 'line_vat', label: 'IVA valor' },
  ]},
  { value: 'tax_summary_rows', label: 'Resumo de Impostos', defaultColumns: [
    { field: 'rate', label: 'Taxa', width: 50, align: 'center' },
    { field: 'base', label: 'Base', width: 110, align: 'right' },
    { field: 'vat', label: 'IVA', width: 70, align: 'right' },
    { field: 'total', label: 'Total', width: 90, align: 'right' },
  ], fields: [
    { value: 'rate', label: 'Taxa' },
    { value: 'base', label: 'Base' },
    { value: 'vat', label: 'IVA' },
    { value: 'total', label: 'Total' },
    { value: 'reason', label: 'Motivo / Isenção' },
  ]},
  { value: 'payments', label: 'Tabela Pagamentos', defaultColumns: [
    { field: 'date', label: 'Data', width: 80, align: 'left' },
    { field: 'method', label: 'Forma de Pagamento', width: 80, align: 'left' },
    { field: 'reference', label: 'Referência', width: 100, align: 'left' },
    { field: 'amount', label: 'Valor', width: 80, align: 'right' },
    { field: 'type', label: 'Tipo', width: 60, align: 'left' },
  ], fields: [
    { value: 'date', label: 'Data' },
    { value: 'method', label: 'Método' },
    { value: 'reference', label: 'Referência' },
    { value: 'amount', label: 'Valor' },
    { value: 'type', label: 'Tipo' },
  ]},
  { value: 'company_banks', label: 'Tabela Dados Bancários', defaultColumns: [
    { field: 'label', label: 'Banco', width: 90, align: 'left' },
    { field: 'bank_name', label: 'Nome', width: 150, align: 'left' },
    { field: 'bank_account_number', label: 'Conta', width: 120, align: 'left' },
    { field: 'bank_iban', label: 'IBAN', width: 165, align: 'left' },
    { field: 'bank_swift', label: 'SWIFT', width: 80, align: 'left' },
  ], fields: [
    { value: 'label', label: 'Banco' },
    { value: 'bank_name', label: 'Nome' },
    { value: 'bank_account_holder', label: 'Titular' },
    { value: 'bank_account_number', label: 'Conta' },
    { value: 'bank_nib', label: 'NIB' },
    { value: 'bank_iban', label: 'IBAN' },
    { value: 'bank_swift', label: 'SWIFT' },
  ]},
];

export const cloneDatasourceColumns = (columns = []) => columns.map((column) => ({ ...column }));

export const buildVariableOptionsFromCatalog = (catalog) => {
  if (!catalog?.variable_groups?.length) return FALLBACK_VARIABLE_GROUPS;
  return catalog.variable_groups.map((group) => ({
    group: group.group,
    items: (group.items || []).map((item) => ({
      path: item.path,
      label: item.label || item.path,
      module: item.module,
      doc_types: item.doc_types || [],
      existing_in_templates: item.existing_in_templates,
      source_origin: item.source_origin,
      stability: item.stability,
      editability: item.editability,
      contract_kind: item.contract_kind,
    })),
  }));
};

export const flattenVariableOptions = (groups = []) => groups.flatMap((group) => group.items || []);

export const buildTableDatasourcesFromCatalog = (catalog) => {
  const datasourceItems = (catalog?.flat_items || []).filter((item) => item.kind === 'datasource');
  if (!datasourceItems.length) return FALLBACK_TABLE_DATASOURCES;

  return datasourceItems.map((item) => ({
    value: item.path,
    label: item.label || item.path,
    defaultColumns: cloneDatasourceColumns(item.defaultColumns || []),
    fields: cloneDatasourceColumns(item.fields || []),
    module: item.module,
    source_origin: item.source_origin,
    stability: item.stability,
    editability: item.editability,
    contract_kind: item.contract_kind,
  }));
};

export const getTableDatasourceMeta = (value, datasources = FALLBACK_TABLE_DATASOURCES) => {
  return datasources.find((item) => item.value === value) || datasources[0] || FALLBACK_TABLE_DATASOURCES[0];
};

export const getElementDisplayLabel = (element, variableOptions = FALLBACK_VARIABLE_GROUPS, tableDatasources = FALLBACK_TABLE_DATASOURCES) => {
  if (!element) return 'Elemento';

  if (element.type === 'text') {
    return element.text?.trim() || 'Texto';
  }

  if (element.type === 'variable') {
    return variableOptions
      .flatMap((group) => group.items || [])
      .find((item) => item.path === element.variablePath)?.label || element.variablePath || 'Variável';
  }

  if (element.type === 'table') {
    return tableDatasources.find((item) => item.value === element.datasource)?.label || 'Tabela';
  }

  if (element.type === 'image') {
    return element.dataUrl ? 'Imagem carregada' : 'Imagem';
  }

  if (element.type === 'rect') return 'Rectângulo';
  if (element.type === 'line') return 'Linha';
  return element.type || 'Elemento';
};